// Type Definitions
import type { UploadFile } from "antd/lib/upload/interface";

// Utils
import { getFiles } from "utils/GetUrlAsFile";

export const getTotalUploadSize = async (uploadedFiles: UploadFile<any>[]) => {
	let totalFileSize = 0;
	for (let i = 0; i < uploadedFiles?.length; i++) {
		totalFileSize = totalFileSize + (uploadedFiles[i]?.size ?? 0);
	}
	// Return the File size in MB
	return totalFileSize / 1024 / 1024;
};

export const getBlobSize = async (files: string[]) => {
	let existingFileSize = 0;
	for (const url of files) {
		const blobData = await getFiles(url);
		existingFileSize = existingFileSize + (blobData !== "" && blobData ? blobData.size : 0);
	}
	// Return the File size in MB
	return existingFileSize / 1024 / 1024;
};
